import { createDuplicateForeignContactsAliasNameValidator } from 'forms/shared/validators/models/name/name';
import { DeepSafePartial } from 'types/types';
import { otherNamesOptions } from 'constants/enums/relationshipOptions';
import { BranchCollectionModel } from 'forms/shared/types/branchCollection';
import { ForeignContactsItemAliasesModel, ForeignContactsItemModel } from '../types';

export const createPvqAliasesValidator = (
  aliasesValue: DeepSafePartial<BranchCollectionModel<ForeignContactsItemAliasesModel>>,
  aliasesAttributes: DeepSafePartial<ForeignContactsItemModel>
) => ({
  Alias: (value, attributes, attributeName, options = {}) => ({
    model: {
      validator: createDuplicateForeignContactsAliasNameValidator(aliasesValue, aliasesAttributes)
    },
  }),

  AliasDescription: {
    hasValue: {
      validator: { inclusion: otherNamesOptions },
    },
  },

  AliasDescriptionOtherExplanation: (value, attributes, attributeName, options = {}) => {
    if (attributes?.AliasDescription?.value === 'Other') {
      return { hasValue: true };
    }

    return {};
  },
});
